import React from 'react';
import { Accordion, Alert, Center, Container, Stack, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconAlertCircle } from '@tabler/icons';
import { NavLink, useLoaderData } from 'react-router-dom';
import SectionTechnologyList from '../../Components/SectionTechnologyList';
import { AggregatedDataLoaderResult } from '../../Loaders/AggregatedDataLoader';
import Radar from '../Radar';
import { groupBy } from '../Radar/util';

const StartPage = () => {
  const { technologies, rings, sections, persons } = useLoaderData() as AggregatedDataLoaderResult;

  const smallScreen = useMediaQuery('(max-width: 1500px)');

  if (smallScreen) {
    return (
      <Container size="lg">
        <Alert variant="light" icon={<IconAlertCircle />} title="Bummer!" w={'fit-content'} maw={400} mb={'xl'}>
          {
            <>
              Radar is only available for screens wider than 1500px - you'll have to make do with this list version.
              Head over to <NavLink to={'/technologies'}>{'technology list'}</NavLink> to be able to use filters.
            </>
          }
        </Alert>
        <Accordion>
          {sections.map((section) => {
            const sectionGroupedByRing = groupBy(
              technologies.filter((t) => t.section?.name === section.name),
              'ringId',
            );

            return (
              <Stack key={section.name}>
                <Title order={1}>{section.name}</Title>
                <SectionTechnologyList groupedResult={sectionGroupedByRing} rings={rings} persons={persons} />{' '}
              </Stack>
            );
          })}
        </Accordion>
      </Container>
    );
  }
  return (
    <Container h={'100%'} fluid>
      <Center h={'100%'}>
        <Radar technologies={technologies} rings={rings} sections={sections} persons={persons} />
      </Center>
    </Container>
  );
};

export default StartPage;
